module.exports = __webpack_public_path__ + "static/media/doctor3.63bee52a.png";